export const MAX_THUMBNAIL_DIMENSIONS_RATIO = 31 / 40;
export const DELAY_AFTER_INFOGRAPH_LOADS_TO_SHOW_INTERACTIVE = 400;
